import { registerModal } from 'features/Modal/ModalRegistry'
import { showModal } from 'features/Modal/Modal.actions'
import ChangePasswordFormModal from './ChangePasswordFormModal'

export const modalType = 'CHANGE_PASSWORD_FORM_MODAL'
registerModal(modalType, ChangePasswordFormModal)

export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ChangePasswordFormModal/ChangePasswordFormModal.action.js